module.exports = __webpack_public_path__ + "img/header.73121a91.svg";